import script from "./RcLabels.vue?vue&type=script&setup=true&lang=ts"
export * from "./RcLabels.vue?vue&type=script&setup=true&lang=ts"

import "./RcLabels.vue?vue&type=style&index=0&id=7bd295b5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bd295b5"]])

export default __exports__